module.exports = __webpack_public_path__ + "static/media/GooglePlay.c5932540.png";